module.exports = __webpack_public_path__ + "41734a85afa84f3aa7408678349176b4.svg";